module.exports = __webpack_public_path__ + "a809d4cbd9ea7c40e0f4de1e8c126470.png";


//////////////////
// WEBPACK FOOTER
// ./work/caoua/img/mid.png
// module id = 724
// module chunks = 0